var map = {
	"./acepta/acepta.module": [
		"./src/app/acepta/acepta.module.ts",
		"common",
		"acepta-acepta-module"
	],
	"./calificacion/calificacion.module": [
		"./src/app/calificacion/calificacion.module.ts",
		"common",
		"calificacion-calificacion-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"common",
		"home-home-module"
	],
	"./lista-tarifas/lista-tarifas.module": [
		"./src/app/lista-tarifas/lista-tarifas.module.ts",
		"lista-tarifas-lista-tarifas-module"
	],
	"./menu/menu.module": [
		"./src/app/menu/menu.module.ts",
		"menu-menu-module"
	],
	"./pedidos/pedidos.module": [
		"./src/app/pedidos/pedidos.module.ts",
		"default~pedidos-pedidos-module~solicitud-solicitud-module~tablapedidos-tablapedidos-module",
		"common",
		"pedidos-pedidos-module"
	],
	"./reporte-tarifas/reporte-tarifas.module": [
		"./src/app/reporte-tarifas/reporte-tarifas.module.ts",
		"reporte-tarifas-reporte-tarifas-module"
	],
	"./reporte/reporte.module": [
		"./src/app/reporte/reporte.module.ts",
		"reporte-reporte-module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"signup-signup-module"
	],
	"./solicitud/solicitud.module": [
		"./src/app/solicitud/solicitud.module.ts",
		"default~pedidos-pedidos-module~solicitud-solicitud-module~tablapedidos-tablapedidos-module",
		"common",
		"solicitud-solicitud-module"
	],
	"./tablapedidos/tablapedidos.module": [
		"./src/app/tablapedidos/tablapedidos.module.ts",
		"default~pedidos-pedidos-module~solicitud-solicitud-module~tablapedidos-tablapedidos-module",
		"common",
		"tablapedidos-tablapedidos-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;